import { css } from '@emotion/react';
import { applyFont, tokens } from '@domain-group/fe-brary';
import { media } from '../../styles/breakpoints-2026';

const { colors, spacing, borderRadius, typography } = tokens;

export const MOBILE_BANNER_HEIGHT = '76px';
const SWAP_TRANSITION = 'transform 200ms ease-out, opacity 200ms ease-out';
const MOBILE_MOTION = `${media('<tablet')} and (prefers-reduced-motion: no-preference)`;

export const banner = ({
  brandColour,
  isDarkBackground,
}: {
  brandColour?: string;
  isDarkBackground: boolean;
}) => {
  const textColour = isDarkBackground ? 'rgba(255, 255, 255, 0.95)' : '#000000';

  return css`
    ${applyFont(typography.mini)}
    align-items: flex-start;
    background-color: ${brandColour || colors.neutral.surface.default};
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0;
    box-sizing: border-box;
    color: ${textColour};
    display: flex;
    flex-direction: column;
    gap: ${spacing.xs};
    height: 88px;
    line-height: 16px;
    max-height: 88px;
    padding: calc(${spacing.xxs} + ${spacing.xs}) ${spacing.m} ${spacing.s};

    ${media('>=desktop')} {
      margin: 0 auto;
      max-width: 1248px;
      width: 100%;
    }

    ${media('>lrg-desktop')} {
      border-radius: ${borderRadius.outer};
    }

    ${media('>=tablet', '<desktop')} {
      height: 84px;
      max-height: 84px;
      padding: ${spacing.xs} 28px ${spacing.s};
    }

    ${media('<tablet')} {
      align-items: center;
      gap: ${spacing.xxs};
      height: ${MOBILE_BANNER_HEIGHT};
      justify-content: center;
      max-height: ${MOBILE_BANNER_HEIGHT};
      padding: ${spacing.s} ${spacing.l};
      width: 100%;
    }
  `;
};

export const logoLink = css`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  min-height: 40px;
  min-width: 114px;

  ${media('<tablet')} {
    min-width: 0;
    width: 100%;
  }
`;

export const logo = css`
  display: block;
  max-height: 40px;
  max-width: 114px;
  object-fit: contain;

  ${media('<tablet')} {
    max-height: 32px;
    max-width: 91px;
    margin: 0 auto;
  }
`;

export const address = css`
  color: currentColor;
  margin: 0;
  padding-left: ${spacing.xxs};
  width: 100%;

  ${media('<lrg-desktop')} {
    padding-left: 0;
  }
`;

export const mobileLine = css`
  display: none;

  ${media('<tablet')} {
    display: grid;
    flex-shrink: 0;
    overflow: hidden;
    text-align: center;
    width: 100%;
  }
`;

const swapLine = css`
  grid-area: 1 / 1;

  ${MOBILE_MOTION} {
    transition: ${SWAP_TRANSITION};
  }
`;

export const mobileSuburb = (showAgentName: boolean) => css`
  ${swapLine}

  ${showAgentName &&
  css`
    opacity: 0;
    transform: translateY(-100%);
  `}
`;

export const mobileAgentName = (showAgentName: boolean) => css`
  ${swapLine}
  opacity: ${showAgentName ? 1 : 0};
  transform: ${showAgentName ? 'none' : 'translateY(100%)'};
`;

export const desktopAddress = css`
  ${media('<tablet')} {
    display: none;
  }
`;
